import { Select } from "antd";
import * as React from "react";
import { useEffect } from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectLedgerDFPSMulti {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectLedgerDFPSMulti = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectLedgerDFPSMulti) => {
  const itemList = useStoreState((state) => state.ledger.cashDFPSLedgerList);

  const itemListFetch = useStoreActions((state) => state.ledger.fetchcashDFPSLedgerList);

  useEffect(()=>{
    itemListFetch();
  },[])

  const onSelect = (id) => {
    console.log(id)
    if (itemList) {
     // const val = itemList.find((item) => item.ledgerId === id);
      onChange(id);
    }
  };




  return (
    <Select
      onChange={onSelect}
      mode="multiple"
      // loading={loading}
      showSearch
      // allowClear
      defaultValue={defaultSelected}
      value={selected}
      style={style}
      allowClear
      placeholder="Select Category"
      filterOption={(input, option:any) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.ledgerId} value={type.ledgerId}>
            {type.ledgerName}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Category</Option>
      )}
    </Select>
  );
};
